import { render } from "./IT_solutions.vue?vue&type=template&id=bd9835e2"
import script from "./IT_solutions.vue?vue&type=script&lang=js"
export * from "./IT_solutions.vue?vue&type=script&lang=js"
script.render = render

export default script